var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvasEventCheckout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 89.9999,
    height: 89.9999,
    rx: 15,
    transform: "matrix(0.707107 0.707106 -0.707107 0.707106 64 0)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 33.6396,
    width: 60,
    height: 59.9999,
    rx: 30,
    fill: "#EDF0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.125 46.7646H50.875L51.625 50.5146M54.625 65.5146H73.375L80.875 50.5146H51.625M54.625 65.5146L51.625 50.5146M54.625 65.5146L50.3258 69.8138C49.1446 70.995 49.9812 73.0146 51.6517 73.0146H73.375M73.375 73.0146C71.3039 73.0146 69.625 74.6935 69.625 76.7646C69.625 78.8357 71.3039 80.5146 73.375 80.5146C75.4461 80.5146 77.125 78.8357 77.125 76.7646C77.125 74.6935 75.4461 73.0146 73.375 73.0146ZM58.375 76.7646C58.375 78.8357 56.6961 80.5146 54.625 80.5146C52.5539 80.5146 50.875 78.8357 50.875 76.7646C50.875 74.6935 52.5539 73.0146 54.625 73.0146C56.6961 73.0146 58.375 74.6935 58.375 76.7646Z",
    stroke: "#4C6FFF",
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasEventCheckout);
export default __webpack_public_path__ + "static/media/canvas_event_checkout.6525c7186d6789db9afe054e8913a116.svg";
export { ForwardRef as ReactComponent };